import { Box, Button, Card, Checkbox, Link, Tab, Table, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import NavigationBar from '../../components/Navigationbar/Navigationbar';
import { useNavigate, useParams } from 'react-router-dom';
import { post, Token } from '../../Script/Session';
import { haspermission } from '../../Script/Permission';
import { has } from 'lodash';

function OrganisationTable() {
    const [wit, setWit] = useState("90.5%");
    const { id } = useParams();
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const [hasperm, sethasperm] = useState(haspermission("31"));
    useEffect(() => {
        function F() {
            let body = {};
            body.token = Token.get();
            body.action = "get";
            body.id = id;
            let response = post(body, "/organisation");
            if (response == "LOGOUT") {
                navigate("/");
                return;
            }
            setData(JSON.parse(response));
        }
        setTimeout(() => {
            F();
        }, 15);
    }, []);
    const [editfields, seteditfields] = useState(false);

    function createfield() {
        let body = {};
        body.token = Token.get();
        body.action = "addvalue";
        body.id = id;
        let a = prompt("Bitte Feldnamen eingeben");
        if (!a) {
            return;
        }
        body.value = a;
        let response = post(body, "/organisation");
        window.location.reload();
    }
    function delval(delval) {
        let body = {};
        body.token = Token.get();
        body.action = "removevalue";
        body.id = id;
        body.value = delval;
        let response = post(body, "/organisation");
        window.location.reload();
    }
    const [owndata, setowndata] = useState(false);
    const [owndatalist, setowndatalist] = useState([]);
    function setow() {
        const user = data.users.find(g => g.name === data.onwname); // use === and no `.first()`

        if (user && Array.isArray(user.value)) {
            setowndatalist([...user.value]); // spread into new array
        } else {
            setowndatalist([]); // fallback if no array
        }
    }
    function saveown() {
        let body = {};
        body.token = Token.get();
        body.action = "setvalues";
        body.id = id;
        body.values = owndatalist;
        let response = post(body, "/organisation");
        window.location.reload();
    }
    if (!data) {
        return <>Loading...</>;
    }

    return (
        <>
            <Box
                sx={{
                    width: wit,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "background.body",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                }}
            >


                <Box sx={{ display: "flex", flexDirection: "row", gap: 2, width: "100%", mt: 1, alignItems: "center", justifyContent: "center" }}>
                    <Button onClick={() => { setowndata(true); setow() }}>Eigene Daten setzen</Button>
                    {
                        hasperm && (

                            <Button onClick={() => seteditfields(true)}>Felder Bearbeiten</Button>

                        )
                    }
                    {
                        hasperm && (
                            <Button onClick={() => navigate("/page-history/organisation")}>Historie</Button>
                        )
                    }
                </Box>
                {
                    owndata && (
                        <Card sx={{ width: "96%", mt: 2, mb: 5 }}>
                            <Typography>Eigene Dateien</Typography>
                            {
                                data.keys.map((item) => (
                                    <Checkbox
                                        key={item.name}
                                        checked={owndatalist.includes(item.name)}
                                        onChange={(e) => {
                                            const updated = e.target.checked
                                                ? [...owndatalist, item.name]
                                                : owndatalist.filter(h => h !== item.name);
                                            setowndatalist(updated);
                                        }}
                                        label={item.name}
                                    />
                                ))
                            }
                            <Button onClick={() => saveown()} sx={{ width: "10%" }}>Speichern</Button>
                        </Card>
                    )
                }
                {
                    editfields && (
                        <Table sx={{ mt: 4, mb: 40 }}>
                            <thead>
                                <tr>
                                    <th>Feld</th>
                                    <th><Button onClick={() => createfield()}>Feld erstellen</Button></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.keys.map((item) => {
                                        return (
                                            <tr>
                                                <td>{item.name}</td>
                                                <td><Button color='danger' onClick={() => delval(item.name)}>Löschen</Button></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>



                    )
                }


                <Table sx={{ mt: 2 }}>
                    <thead>
                        <tr>
                            <th>Feld</th>
                            <th>Personen</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.keys.map((item) => {
                                return (
                                    <tr>
                                        <td>{item.name}</td>
                                        <td>{
                                            data.users.map((a) => {
                                                if (a.value.includes(item.name)) {
                                                    return (
                                                        <>{a.name},</>
                                                    )
                                                } else {
                                                    return ("");
                                                }
                                            })
                                        }</td>
                                    </tr>


                                )


                            })
                        }
                    </tbody>


                </Table>






            </Box>





            <NavigationBar state="profile" back={true} />
        </>
    );
}

export default OrganisationTable;
